import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import JobCampaignsAPI from '../../../../utils/api/jobCampaignsAPI';

const entity = new ReduxRestEntity({
  name: 'jobCampaigns',
  api: JobCampaignsAPI(),
});

export default entity;
